import { SubscriptionScopeKey } from "../../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
import { RowType } from "../../../../components/Editable/FormItem/Rows/RowType";
import { processItemsMultiOther, processItemsMultiUom } from "./processItemsMultiSeries";
import { processItemsRemoval } from "./processItemsRemoval";

/**
 *
 * @param {Array} formItems
 * @param {Array} productList - From ListApi
 * @param {String} initType - 'transfer' / 'duplicate' / 'copy' / 'copyItems'
 * @param {Object} originTransaction  - ONLY used when initType === 'transfer'
//  * @param {String} processMode - 'remove' to remove line; or 'base' to replace with base uom
 * @returns {
 *  processedFormItems: Array, // initial process for Transfer related Info
 *  finalFormItems: Array,     // final process for Subscription related Info
 *  nonBaseUomItems: Array // formItems with non-base uom
 * }
 */
export const processFormItems = ({
    formItems = [],
    productList,
    settings,
    initType,
    originTransaction, // ONLY used when initType === 'transfer'
    // processMode = 'remove', // to remove line; or 'base' to replace with base uom
}) => {
    const processedFormItems = formItems.map(formItem => {
        // Ignore subtitle and subtotal lines
        if ([RowType.subtotal, RowType.subtitle].includes(formItem.type))
            return formItem;

        let newFormItem;
        switch (initType) {
            case 'transfer': {
                const productClassificationCode = productList.find(
                    p => p.id === formItem.product_id)?.classification_code;

                newFormItem = {
                    ...formItem,
                    transfer_transaction: {
                        id: originTransaction.id,
                        type: originTransaction.type,
                        number: originTransaction.number,
                        date: originTransaction.date,
                    },
                    transfer_item_id: formItem.id,
                    quantity: formItem.balance_quantity,
                    classification_code: productClassificationCode,
                };

                // get product classification code for bundle items
                if (newFormItem.children?.length > 0) {
                    newFormItem.children.forEach((child, idx) => {
                        const childClassificationCode = productList.find(
                            p => p.id === child.product_id)?.classification_code;

                        newFormItem.children[idx].classification_code = childClassificationCode;
                    });
                }

                return (newFormItem.quantity === 0) ? false : newFormItem;
            }
            case 'restoreAutosave':
                newFormItem = {
                    ...formItem,
                    // transfer_transaction: {
                    //     id: originTransaction.id,
                    //     type: originTransaction.type,
                    //     number: originTransaction.number,
                    //     date: originTransaction.date,
                    // },
                    // transfer_item_id: formItem.id,
                    // quantity: formItem.balance_quantity,
                };
                return (newFormItem.quantity === 0) ? false : newFormItem;
            default:
                // Remove transfer transaction information
                newFormItem = {
                    ...formItem,
                    transfer_transaction: undefined,
                    transfer_item_id: undefined,
                    balance_quantity: undefined,
                    transferred_to_quantity: undefined,
                };
                return newFormItem;
        }
    }).filter(i => !!i);

    const {
        newItems: postBundleItems,
        removedItems: removedBundles,
    } = processItemsRemoval({
        items: processedFormItems,
        productList,
        subscriptionScopeKey: SubscriptionScopeKey['PRODUCT.BUNDLE'],
        checkShouldRemoveItem: item => {
            const shouldRemoveItem = item.type === RowType.bundle;
            return shouldRemoveItem;
        },
    });

    const {
        newItems: postUOMFormItems,
        removedItems: nonBaseUomItems,
    } = processItemsMultiUom({
        items: postBundleItems,
        productList,
        // processMode,
    });

    const {
        newItems: finalFormItems,
        hasLocationChange,
        hasTaxChange,
    } = processItemsMultiOther({
        items: postUOMFormItems,
        settings,
    });

    // console.log('aaa processFormItems', {
    //     processedFormItems,
    //     postBundleItems,
    //     finalFormItems,
    //     removedBundles,
    //     nonBaseUomItems,
    // });
    return {
        processedFormItems,
        finalFormItems,
        removedBundles,
        nonBaseUomItems,
        hasTaxChange,
        hasLocationChange,
    };
};
